import axios from "axios";

// Production API url and key
const defaultApiUrl = "https://tmi-uploaderfunctions.azurewebsites.net";
const defaultApiKey = "/4l/DO9rCA/BoqZ31NLsoIgzztDs17giZTvwbz2/IhPeM/9BJftXKA==";

// Allow overriding production api url/key for local dev or dev/staging environments
const apiUrl = process.env.VUE_APP_API_URL ?? defaultApiUrl;
const apiKey = process.env.VUE_APP_API_KEY ?? defaultApiKey;

const eqDataEndpoint = `${apiUrl}/api/GetEquipmentData?code=${apiKey}`;
const stockNoSearchEndpoint = `${apiUrl}/api/GetStockNumbers?code=${apiKey}`;
const archivedImagesEndpoint = `${apiUrl}/api/GetArchivedData?code=${apiKey}`;
const imageDataEndpoint = `${apiUrl}/api/GetImageData?code=${apiKey}`;
const regionsEndpoint = "https://www.titanmachinery.com/api/default/locations?$select=LocationDisplayName&$filter=LocationAddress/CountryCode%20eq%20%27US%27&$orderby=LocationDisplayName%20asc";

let config = {
  headers: {
    ContinuationToken: "",
  },
};

export function getAllEquipmentData(token, recursive) {
  let requestConfig = {
    method: "post",
    url: eqDataEndpoint,
      headers: {
          ContinuationToken: token,
    },
  };

  return new Promise((resolve, reject) => {
    axios
      .post(requestConfig.url, requestConfig.headers)
        .then((response) => {
        if (!recursive && token != "") {
          resolve(response);
        } else {
            getAllEquipmentData(token, recursive).then((res) => {
              response.data.Data = response.data.Data.concat(res.data.Data);
            resolve(response);
          });
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getEquipmentById(id) {
    return new Promise((resolve, reject) => {
        var timestamp = new Date().getTime();
    axios
        .get(`${eqDataEndpoint}&StockNumber=${id}&t=${timestamp}`, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// UploadHistory filter-search. POSTs the partial stock filter and selected
// location list to GetEquipmentData; the backend recognizes
// StockNumberFilter / Locations and runs a CONTAINS / STARTSWITH query
// across the entire equipment collection (not just the recent-activity TOP
// 200 that getAllEquipmentData returns). Returns the full Data list.
export function searchEquipmentByFilters(stockNumberFilter, locations) {
  return new Promise((resolve, reject) => {
    axios
      .post(eqDataEndpoint, {
        StockNumberFilter: stockNumberFilter || "",
        Locations: locations || [],
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function searchEquipmentByStockNo(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${stockNoSearchEndpoint}&searchParam=${id}`, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getArchivedImagesByMachine(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${archivedImagesEndpoint}&StockNumber=${id}`, config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getImageById(stockNo, image) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${imageDataEndpoint}&StockNumber=${stockNo}&ImageId=${image}`, { responseType: 'arraybuffer' })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function getRegions() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${regionsEndpoint}`, { responseType: 'arrayBuffer' })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  getAllEquipmentData,
  getEquipmentById,
  searchEquipmentByStockNo,
  searchEquipmentByFilters,
  getArchivedImagesByMachine,
  getImageById,
  getRegions
};
